import { create } from "zustand";
import type { ResetPasswordState } from "./types";

export const useResetPasswordStore = create<ResetPasswordState>((set) => ({
  isLoading: false,
  errorMessage: null,
  password: "",
  confirmPassword: "",
  setPassword: (password) => set({ password }),
  setConfirmPassword: (confirmPassword) => set({ confirmPassword }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (message) => set({ errorMessage: message }),
  reset: () =>
    set({
      isLoading: false,
      errorMessage: null,
      password: "",
      confirmPassword: "",
    }),
}));
